// Contains the data content for Onboarding Guide Banner
import { AssetHost } from '../../../config'
import _ from 'lodash'

export const teacher_selfStartPath = {
    hasVisitedStorylines: {
        contextValue: 'exploreContent',
        mainTitle: 'Explore Content',
        mainText:
            'Go to “Explore & Assign” on to check out our contents. Take a look at at least one storyline.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'modules?userflow=8f43fc33-bac7-4224-ad58-9addac4ea3e5',
                text: 'Show Me',
                isExternal: false
            }
        ]
    },
    hasSelfAssigned: {
        contextValue: 'assignYourself',
        mainTitle: 'Assign To Yourself',
        mainText: 'Go to “Explore & Assign” to assign something to yourself.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'modules?userflow=5d31d554-7344-4ed4-b503-8e50e31e860c',
                text: 'Show Me',
                isExternal: false
            },
            {
                actionType: 'button',
                style: 'white',
                text: 'Skip',
                ixExternal: false
            }
        ]
    },
    hasCreatedCharacter: {
        contextValue: 'getInGame',
        mainTitle: 'Get Into the Game',
        mainText: 'Go to “Play the Game” to open the game.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: AssetHost(),
                text: 'Go',
                isExternal: true
            }
        ]
    },
    hasCompletedQuest: {
        contextValue: 'completeQuest',
        mainTitle: 'Complete your first Quest',
        mainText: 'Go to “Play the Game” to open the game and complete a quest.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: AssetHost(),
                text: 'Go',
                isExternal: true
            }
        ]
    }
}

export const teacher_studentStartPath = {
    hasCreatedClass: {
        contextValue: 'createClass',
        mainTitle: 'Create a Class',
        mainText: 'Go to “ Manage Classes” to create a class.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'classes?userflow=7b9cdd8f-a669-438b-9b17-683f2ff39bef',
                text: 'Show Me',
                isExternal: false
            }
        ]
    },
    hasPopulatedClass: {
        contextValue: 'addStudent',
        mainTitle: 'Add Students to A class',
        mainText: 'Go to your empty class in “Manage Classes” to add students.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'classes?userflow=1e5832c5-5ec5-4b9b-b7a9-de77a35864ac',
                text: 'Show Me',
                isExternal: false
            }
        ]
    },
    hasStudentCreatedCharacter: {
        contextValue: 'studentInGame',
        mainTitle: 'Get Students Into the Game',
        mainText: 'Ask your students to click on “Play the Game” to open the game.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'https://docs.google.com/presentation/d/1gXa_e8PQzkLGNypG7fMp8nyQgiT0E4TVV4jtSeemCTc/edit#slide=id.p',
                text: 'Instructions',
                isExternal: true
            }
        ]
    },
    hasCreatedStudentAssignment: {
        contextValue: 'assignToStudent',
        mainTitle: 'Assign to Students',
        mainText: 'Go to “Explore & Assign” to assign something to your students.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                url: 'modules?userflow=12327bf8-f58b-467f-8f7e-8bf000e2aa60',
                text: 'Show Me',
                isExternal: false
            },
            {
                actionType: 'button',
                style: 'white',
                text: 'Skip',
                isExternal: false
            }
        ]
    },
    hasStudentCompletedQuest: {
        contextValue: 'studentCompleteQuest',
        mainTitle: 'Students complete First Quests',
        mainText: 'Get your students into the game and complete a quest.'
    }
}
